<template>
  <div id="dialog-insu-company-picker">
    <span class="cls" @click="cancle()"></span>
    
    <div class="paper">
      <ul class="tab">
        <li @click="toggleChapter(0)"  :class="chapter_select == 0 ? 'active' : ''"><span>손해</span></li>
        <li @click="toggleChapter(1)"  :class="chapter_select == 1 ? 'active' : ''"><span>생명</span></li>
        <li @click="toggleChapter(2)"  :class="chapter_select == 2 ? 'active' : ''"><span>기타</span></li>
        <li v-if="onlyChose == true" @click="toggleChapter(3)"  :class="chapter_select == 3 ? 'active' : ''"><span>기관</span></li>
      </ul>
      <div class="content">
        <ul v-if="chapter_select == 0" :class="chapter_select == 0 ? 'active' : ''">
          <li @click="selectCompany({value:'etc'})" v-if="!onlyChose">
            <img src="https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-no-image-available-icon-flatvector-illustration-picture-coming-creative-vector-png-image_40968940.jpg"/>
            <span class="name">직접 입력</span>
          </li>
          <template v-for="(company, index) in insuCompanys" :key="index">
            <li v-if="company.type == 'fire'" @click="selectCompany(company)">
              <img :src="company.short_img"/>
              <span class="name">{{ company.name }}</span>
            </li>
          </template>
        </ul>
        <ul v-if="chapter_select == 1" :class="chapter_select == 1 ? 'active' : ''">
          <li @click="selectCompany({value:'etc'})" v-if="!onlyChose">
            <img src="https://png.pngtree.com/png-vector/20221125/ourmid/pngtree-no-image-available-icon-flatvector-illustration-picture-coming-creative-vector-png-image_40968940.jpg"/>
            <span class="name">직접 입력</span>
          </li>
          <template v-for="(company, index) in insuCompanys" :key="index">
            <li v-if="company.type == 'life'" @click="selectCompany(company)">
              <img :src="company.short_img"/>
              <span class="name">{{ company.name }}</span>
            </li>
          </template>
        </ul>

        <ul v-if="chapter_select == 2" :class="chapter_select == 2 ? 'active' : ''">
          <template v-for="(company, index) in insuCompanys" :key="index">
            <li v-if="company.type == 'other'" @click="selectCompany(company)">
              <img :src="company.short_img"/>
              <span class="name">{{ company.name }}</span>
            </li>
          </template>
        </ul>

        <ul v-if="chapter_select == 3 && onlyChose == true" :class="chapter_select == 3 ? 'active' : ''">
          <li v-for="(shortcut, index) in extraShortcut" :key="index" @click="openLink(shortcut.link)">
            <img :src="shortcut.img" />
            <span class="name">{{ shortcut.name }}</span>
          </li>
        </ul>

      </div>
      
    </div>

  </div>
</template>

<script>
import { ref, inject } from 'vue';
import { useBackButton } from '@/utils/useBackBtn';

export default ({
  emits: ['submit'],
  props: { 
    onlyChose: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const chapter_select = ref(0);
    const insuCompanys = inject('insuCompanys', ref([]));

    
    useBackButton(() => {cancle();});

    const extraShortcut = [
      { name: 'AMA다이어리', value: 'etc', link:"https://amadiary.com", img:"https://amadiary.com/pub/acon/ama_logo_bg.png" },
      // { name: 'VFT Partner', value: 'etc', link:"", img:"" },
      { name: '탐스2', value: 'etc', link:"https://ktams.kgaasset.com/Install/newLauncher_XP.html", img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPNsT-vWXhvoaMl-N1ZGpjZmKXlCj3oQ78AQ&s" },
      { name: '모홈', value: 'etc', link:"https://www.mohom.kr/", img:"https://cdn.litt.ly/images/6EOhVOPX4lCq3kgkBbkVIovtbNw238PZ?s=180x180&f=webp" },
      { name: '정부(민원)24', value: 'etc', link:"https://plus.gov.kr/", img:"https://play-lh.googleusercontent.com/9ZwlSxrZ5zAGydEtON0V6SkvezO_v6xIlbQEIYR7AKPiJ7NLoYow-2LYjmRH48FC1b3CXBicR4DJw3zZ-GXi" },
      { name: '대법원', value: 'etc', link:"https://www.scourt.go.kr/scourt/index.html", img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLLeAL3Vd9nzMdUR1bYn8c6vGNawjWUkY6dg&s" },
      // { name: '온라인청구?', value: 'etc', link:"", img:"" },
      { name: '보험연수원', value: 'etc', link:"https://www.in.or.kr/", img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_XY3ix2gGJaqNatDNchSgIDw4GiamKZwelg&s" },
      { name: '생보협회', value: 'etc', link:"https://www.klia.or.kr/", img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTn-aJSouIvG2-yL6m22NDqUZ-EfF8Kw3gwtw&s" },
      { name: '손보협회', value: 'etc', link:"https://www.knia.or.kr/", img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNa09N7yNPymtGoISiXJpI1IERXw9d3IYXlA&s" },
      { name: '금감원', value: 'etc', link:"https://www.fss.or.kr/fss/main", img:"https://cdn.smarttoday.co.kr/news/photo/202406/52141_45647_2216.jpg" },
    ];

    function openLink(link) {
      window.open(link);
    }

    function toggleChapter(index) {
      chapter_select.value = index;
    }

    function cancle() {
      // Emit an event to close the dialog
      emit('submit', null);
    }

    function selectCompany(company) {
      // Emit the selected company
      emit('submit', company);
    }

    return {
      insuCompanys,
      chapter_select,
      toggleChapter,
      cancle,
      selectCompany,
      extraShortcut,
      openLink
    };
  },
})
</script>


<style scoped>

#dialog-insu-company-picker {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.paper {
  width: 90%;
  max-width: 480px;
  min-height: 10%;
  height:60%;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

ul.tab {
  display: flex;
  justify-items: center;
  font-size: var(--font-size-md);
  font-weight: bold;
  list-style: none;
  padding: 0;
  margin: 0;
  gap:6px;
}

ul.tab li {
  width:100%;
  height:100%;
  cursor: pointer;
  padding: 8px 16px;
  box-sizing: border-box;
  display:flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid var(--color-background);
}

ul.tab li.active {
  border-bottom: 1px solid var(--color-text-primary);
  color: var(--color-text-light);
}

.content { 
  display: flex;
  align-items: start;
  justify-content: center;
  width:100%;
  max-height: 100%;
  flex:1;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.content::-webkit-scrollbar {
  display: none;
}

.content > ul {
  padding: 0;
  margin: 0;
  width: 100%;
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr); 
  grid-auto-rows: auto;              /* ✅ 내용 높이만큼만 row 높이 */
  gap: 12px;
  align-items: start;                /* ✅ 상단 정렬 */
}

.content > ul > li {
  aspect-ratio: 1 / 1;                  /* ✅ 정사각형 유지 */
  background: var(--color-background-light);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;

  cursor: pointer;
}


.content > ul > li > img {
  width: 60px;
  height: 60px;
  border-radius: 8px;
}


/* 태블릿 (601px ~ 1024px) */
@media (min-width: 601px) and (max-width: 1024px) {
  .paper {
    width: 85%;
    max-width: 560px;
    height: 65%;
    padding: 20px;
  }

  /* 4컬럼 그리드 */
  .content > ul {
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
  }

  .content > ul > li {
    gap: 10px;
  }

  .content > ul > li > img {
    width: 56px;
    height: 56px;
  }

  .content > ul > li > .name {
    font-size: var(--font-size-sm);
  }

  ul.tab li {
    padding: 10px 12px;
  }
}

/* 모바일 (600px 이하) */
@media (max-width: 600px) {
  .paper {
    width: 100%;
    max-width: 100%;
    height: 70%;
    border-radius: 20px 20px 0 0;
    border: none;
    border-top: 2px solid var(--color-background-light);
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 16px;
    animation: slideUp 0.3s ease;
  }

  @keyframes slideUp {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0);
    }
  }

  /* 상단 핸들 바 */
  .paper::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background: var(--color-background-light);
    border-radius: 2px;
  }

  ul.tab {
    margin-top: 8px;
    gap: 4px;
  }

  ul.tab li {
    padding: 10px 8px;
    font-size: var(--font-size-sm);
  }

  /* 3컬럼 유지, 크기 조정 */
  .content > ul {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
  }

  .content > ul > li {
    gap: 8px;
    padding: 8px;
  }

  .content > ul > li > img {
    width: 48px;
    height: 48px;
    border-radius: 6px;
  }

  .content > ul > li > .name {
    font-size: var(--font-size-xs);
    text-align: center;
    word-break: keep-all;
  }
}

/* 작은 모바일 (360px 이하) */
@media (max-width: 360px) {
  .content > ul > li > img {
    width: 40px;
    height: 40px;
  }

  .content > ul > li > .name {
    font-size: 10px;
  }
}


</style>